import { connect } from 'react-redux';
import reduxForm from 'redux-form/es/reduxForm';
import { confirmPhoneNumber } from 'actions/authentication';
import { updateContactsInfo } from 'actions/selfservice';
import { formConfig } from './const/formConfig';
import { mapStateToProps } from './const/mapStateToProps';
import { UpdateDataModalComponent } from './UpdateDataComponent';

export const UpdateDataModal = connect(mapStateToProps, {
  confirmPhoneNumber,
  updateContactsInfo,
})(reduxForm(formConfig)(UpdateDataModalComponent));
